export default __webpack_public_path__ + "static/media/8.1a2da896.jpg";